import { CustomFormFieldBase } from "./custom-form-field.type";

export class ProductPlanSliderFormControl extends CustomFormFieldBase<string> {
    override controlType = 'product-plan-slider'; 
}
